import React from 'react';
import { useReactiveVar } from '@apollo/client';
import { isLoggedInVar } from '@occc-app/Auth/authReactiveVariables';

import { UnauthenticatedApp } from './UnauthenticatedApp';
import { AuthenticatedApp } from './AuthenticatedApp';

export const AppRouter = () => {
  const isLoggedIn = useReactiveVar(isLoggedInVar);

  if (!isLoggedIn) {
    return <UnauthenticatedApp />;
  }

  return <AuthenticatedApp />;
};
